import CardSection from "../../../components/CardSection/CardSection";
import MyMatrixForm from "../../../components/CardSection/MyMatrixForm";
import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Approv = () => {
  const [cardOpen, setCardOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  return loading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 32,
      }}
    >
      <CircularProgress color="primary" size={48} />
      <div style={{ marginTop: 16, fontSize: 18 }}>Chargement...</div>
    </div>
  ) : (
    <CardSection
      title="APPROVISIONNEMENT"
      showDefaultControls={false}
      open={cardOpen}
      setOpen={setCardOpen}
    >
      <MyMatrixForm setOpen={setCardOpen} setLoading={setLoading} />
    </CardSection>
  );
};

export default Approv;
